import script from "./AppNavBar.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppNavBar.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__
import QHeader from 'quasar/src/components/header/QHeader.js';
import QToolbar from 'quasar/src/components/toolbar/QToolbar.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QHeader,QToolbar});
